import { sorted } from "./sorted.js";

/**
 * Compare two lists of sortable elements and return three lists:
 * - elements exclusive to the first input list,
 * - elements common to both input lists, and
 * - elements exclusive to the second input list.
 */
export function comm<T extends number[] | string[]>(left: T, right: T): [T, T, T] {
	left = sorted(left);
	right = sorted(right);

	const onlyLeft: unknown[] = [];
	const common: unknown[] = [];
	const onlyRight: unknown[] = [];

	while (left.length > 0 || right.length > 0) {
		const [l] = left;
		const [r] = right;
		if (l === r) {
			left.shift();
			right.shift();
			common.push(l);
		} else if (r === undefined || (l as T[number]) < r) {
			left.shift();
			onlyLeft.push(l);
		} else if (l === undefined || (r as T[number]) < l) {
			right.shift();
			onlyRight.push(r);
		} else {
			throw new TypeError("Uncomparable elements");
		}
	}
	return [onlyLeft as T, common as T, onlyRight as T];
}
